import React from 'react';
import style from './style.module.less';
import Frame from '../Frame';
import ResponsiveImage from '../ResponsiveImage';
import classNames from 'classnames';

let angleLeft = false;

function Head({ image, hasFrame }) {
    let backgroundImage = undefined;
    angleLeft = !angleLeft;

    if (hasFrame) {
        if (image) {
            backgroundImage = <ResponsiveImage source={'head/' + image} className={style.frame_image} />;
        }
        return (
            <div className={classNames(style.frame_wrapper, { [style.frame_wrapper__angle]: angleLeft })}>
                <Frame className={style.frame}>
                    {backgroundImage}
                    <div className={style.frame_image_wrapper} />
                </Frame>
            </div>
        );
    }

    if (image) {
        backgroundImage = { backgroundImage: 'url(' + require('pages/images/head/' + image) + ')' };
    }

    return <div className={style.image} style={backgroundImage} />;
}

export default Head;



// WEBPACK FOOTER //
// ../components/Head/index.js